'use client';

import { useState } from 'react';
import Footer from '@components/footer/Footer';
import Head from 'next/head';
import styles from './safety.modules.css';
import Navbar from '@components/Navbar';

export default function SafetyPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Navbar />
      <style>
        {`.accordion-item.open .accordion-icon {
    transform: rotate(45deg);
  }`}
      </style>
      <Head>
        <title>Safety | PenguinLearn</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>

      <header className={styles.safetyHero} style={{ backgroundColor: '#f5f5f5', padding: '3rem 0', textAlign: 'center', color: '#333', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', marginBottom: '2rem' }}>
        <div className={styles.container} style={{ textAlign: 'center', backgroundColor: '#f5f5f5', padding: '0 1rem', margin: '0 auto', width: '100%', fontFamily: 'Arial, sans-serif', color: '#333', lineHeight: '1.6' }}>
          <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Trust and Safety</h1>
          <p className={styles.introText} style={{ fontSize: '1.2rem', marginBottom: '1rem', color: '#333', lineHeight: '1.6', fontFamily: 'Arial, sans-serif', fontWeight: '600' }}>
            Giving learners a safe space to grow and innovate.
          </p>
          <p className={styles.introDescription} style={{ fontSize: '1rem', maxWidth: '700px', margin: '0 auto', color: '#555', lineHeight: '1.7', fontFamily: 'Arial, sans-serif' }}>
            PenguinLearn brings together a community of diverse learners, parents, and teachers
            who safely connect over a love of learning. Our users are confident
            that their well-being, privacy, and security will never be compromised.
          </p>
        </div>
      </header>

      <section className={styles.container} style={{ marginLeft: '12px', padding: '3rem 3rem', textAlign: 'flex', color: '#333', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', marginBottom: '2rem' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>How does PenguinLearn create an inclusive learning space?</h2>
        <p style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6', fontFamily: 'Arial, sans-serif', marginBottom: '1.5rem' }}>
          We believe every child deserves an engaging, supportive environment in which they can
          thrive. Our platform is built around community guidelines that promote respect,
          understanding, and open-mindedness. From anti-bullying measures to inclusive representation
          in course materials, PenguinLearn is committed to ensuring that all learners feel
          valued and included.
        </p>
      </section>

      <section className={styles.container} style={{ marginLeft: '12px', padding: '3rem 3rem', textAlign: 'flex', color: '#333', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>How do we safeguard our community?</h2>
        <div className={styles.accordion} style={{ fontSize: '16px', lineHeight: '1.6', fontFamily: 'Arial, sans-serif', color: '#333', borderTop: '1px solid #ddd' }}>
          {[
            {
              title: "Comprehensive Teacher Screening",
              content: "All instructors undergo background checks and credential verification to ensure expertise and safety."
            },
            {
              title: "Safe Platform",
              content: "Our online classrooms feature secure video conferencing tools and strict privacy settings."
            },
            {
              title: "Limited Class Recordings",
              content: "Classes may be recorded only when necessary for quality improvement and securely stored."
            },
            {
              title: "Dedicated Trust and Safety Team",
              content: "Our team monitors classes and teacher-student interactions to ensure a safe learning environment."
            },
            {
              title: "Serious about Privacy Concerns",
              content: "We adhere to strict data protection regulations and never share user information with unauthorized parties."
            },
            {
              title: "General Online Safety Practices",
              content: "We educate our community about best practices like responsible device use and secure passwords."
            }
          ].map((item, index) => (
            <div key={index} className={`${styles.accordionItem} ${openIndex === index ? styles.open : ''}`} style={{ borderBottom: '1px solid #ddd', fontSize: '16px' }}>
              <button className={styles.accordionHeader} style={{ width: '100%', background: 'none', border: 'none', textAlign: 'left', fontSize: '1.25rem', fontWeight: '600', padding: '1rem 0', cursor: 'pointer', color: '#333', position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} onClick={() => toggleAccordion(index)}>
                {item.title}
                <span className={styles.accordionIcon} style={{ marginRight: '2rem', fontSize: '1.5rem', transition: 'transform 0.3s ease', accordionIcon: 'rotate(45deg)' }}>{openIndex === index ? '-' : '+'}</span>
              </button>
              {openIndex === index && (
                <div className={styles.accordionBody} style={{ padding: '1rem 0', fontSize: '16px', lineHeight: '1.6', fontFamily: 'Arial, sans-serif', color: '#333', animation: 'fade-in 0.3s ease forwards' }}>
                  <p>{item.content}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>

      <footer className={styles.container} style={{ padding: '3rem 3rem', textAlign: 'flex', color: '#333', fontFamily: 'Arial, sans-serif', lineHeight: '1.6' }}>
        <p className={styles.contactNote} style={{ fontSize: '1rem', color: '#555', lineHeight: '1.6', fontFamily: 'Arial, sans-serif', marginLeft: '12px' }}>
          Please contact us at: support@penguinlearn.com if you have any questions about our safety policies
          or any safety-related concerns.
        </p>
      </footer>

      <Footer />
    </>
  );
}
